import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

export const DateRangeWrapper = styled.div`
  .rdrDayPassive {
    .rdrDayNumber {
      span {
        color: ${Colors.GreyDarkerMiddle} !important;
      }
    }
  }

  .rdrDayNumber {
    span {
      font-weight: 400;
      color: ${Colors.DarkerText} !important;
      z-index: 2;

      &:after {
        background: ${Colors.BlueDark} !important;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        bottom: 2px;
      }
    }
  }

  .rdrDay {
    height: 28px;
    margin: 2px 0;
  }

  .rdrWeekDay {
    font-size: 12px;
    color: ${Colors.Dark};
  }

  .rdrDateRangeWrapper {
    width: 100%;
  }

  .rdrMonth {
    width: 100%;
    padding-bottom: 10px;
  }

  .rdrDayNumber,
  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    top: 0;
    bottom: 0;
  }

  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    top: 0;
    bottom: 0;
    border: none !important;
    background: ${Colors.BrandBlueTheLightest} !important;
  }

  .rdrMonthAndYearPickers {
    font-size: 12px;
    font-weight: 600;
    color: ${Colors.DarkerMiddle};
  }

  .rdrNextPrevButton {
    background: transparent;
  }

  .rdrDayStartPreview,
  .rdrDayEndPreview,
  .rdrStartEdge,
  .rdrEndEdge {
    background: ${Colors.BrandBlueLight} !important;
  }

  .rdrStartEdge {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    left: 0;
  }

  .rdrEndEdge {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    right: 0;
  }

  .rdrSelected {
    border-radius: 4px;
  }

  .rdrDayStartOfMonth .rdrInRange,
  .rdrDayStartOfMonth .rdrEndEdge,
  .rdrDayStartOfWeek .rdrInRange,
  .rdrDayStartOfWeek .rdrEndEdge {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .rdrDayEndOfMonth .rdrInRange,
  .rdrDayEndOfMonth .rdrStartEdge,
  .rdrDayEndOfWeek .rdrInRange,
  .rdrDayEndOfWeek .rdrStartEdge {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .rdrDayStartOfMonth .rdrDayInPreview,
  .rdrDayStartOfMonth .rdrDayEndPreview,
  .rdrDayStartOfWeek .rdrDayInPreview,
  .rdrDayStartOfWeek .rdrDayEndPreview {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .rdrDayEndOfMonth .rdrDayInPreview,
  .rdrDayEndOfMonth .rdrDayStartPreview,
  .rdrDayEndOfWeek .rdrDayInPreview,
  .rdrDayEndOfWeek .rdrDayStartPreview {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .rdrDayStartPreview {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .rdrDayEndPreview {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
